
import update from 'immutability-helper'
import {pick} from 'lodash'
import React from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import {makeStyles} from 'external/material'

import useForm from '../../../../helpers/form-hook'
import useValidations from '../../../../helpers/validations-hook'
import {createPost} from '../../../../helpers/command'
import {requiredTextAfterAttempt} from '../../../../helpers/validations'

import Dialog from '../../../responsive-fullscreen-dialog'
import TextInput from '../../../text-input'
import Select from '../../../select'

const validations = {
  name: [requiredTextAfterAttempt('name', 'required-name')]
}

const initialState = {
  attempted: false,
  name: ''
}

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    paddingTop: 20,
  },
}))

export default function CreateDirectoryForm ({context}) {

  const {translate, quizDialogs} = context

  const isOpen = quizDialogs['create-directory']

  const classes = useStyles()
  const {state, setState, handleChange, resetState} = useForm(initialState)
  const {errors, errorCount, validate, resetErrors} = useValidations(validations)


  const createStateHandler = mapState => (event) => {
    const value = event.target.value == '' ? undefined : event.target.value
    setState({...state, ...mapState(value)})
  }

  function closeDialog () {
    const quizDialogs = update(context.quizDialogs, {'create-directory': {$set: false}})
    context.setState({quizDialogs})
    resetState()
    resetErrors()
  }

  async function createDirectory() {
    if (validate({...state, attempted: true})) {
      const directory = pick(state, ['name'])
      try {
        const [created] = await createPost('quiz', 'createDirectory')(directory)
        if (created) {
          const quizDirectories = update(context.quizDirectories, {[created.id]: {$set: created}})
          context.setState({quizDirectories, quizAssessmentCalls: context.quizAssessmentCalls + 1})
        }
        else {
          setState({...state, attempted: true})
        }
      } catch (e) {
      }
      closeDialog()
    }
    else {
      setState({...state, attempted: true})
    }
  }

  React.useEffect(() => { validate(state) }, [state])

  return (
    <Dialog
      open={isOpen}
      close={closeDialog}
      confirm={
        <Button
          variant="contained"
          color="primary"
          onClick={createDirectory}>
            {translate('create')}
        </Button>
      }
      cancel={
        <Button
          variant="contained"
          color="secondary"
          onClick={closeDialog}>
            {translate('cancel')}
        </Button>
      }
      title={translate('create-directory-dialog-title')}
    >
        <Box className={classes.root}>
           <TextInput
             controlFullWidth
             controlVariant="outlined"
             id="name"
             inputAutoComplete="name"
             labelRequired
             inputAutoFocus
             caption={translate('name')}
             value={state.title}
             inputOnChange={handleChange('name')}
             controlError={errors.name.length > 0}
             errorMessage={errors.name.length > 0 ? translate(errors.name) : undefined}
           />
        </Box>
    </Dialog>
  )
}
